
import { Vue, Component, Prop } from "vue-property-decorator";
import TableAvatar from "@/components/table/TableAvatar.vue";
import BookmarkIcon from "@/components/common/BookmarkIcon.vue";
import getInitials from "@/helpers/getInitials";
import EmployeeDropdownOption from "@/entities/EmployeeDropdownOption";

@Component({
  components: {
    TableAvatar,
    BookmarkIcon,
  }
})
export default class MultiselectAvatarWithBookmark extends Vue {
  @Prop({ type: Object, required: true }) readonly option!: EmployeeDropdownOption;
  @Prop({ type: Map, default: () => new Map() }) readonly bookmarkedUsers!: Map<string, any>;

  get avatar(): string {
    return this.option?.avatar || "";
  }

  get initials(): string {
    const { given_name:givenName = "", family_name:familyName = "" } = this.option;
    return getInitials(givenName, familyName);
  }

  get isBookmarked(): boolean {
    const userId = this.option?.id;
    const bookmarked = this.bookmarkedUsers.has(userId);
    console.log('🎭 Bookmark check for', this.option?.name, ':', bookmarked);
    return bookmarked;
  }
}
